// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box_content[data-v-7d394093]{height:100%;padding:8px 8px;overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none}.box_content[data-v-7d394093]::-webkit-scrollbar{display:none}", ""]);
// Exports
module.exports = exports;
